var map = {
	"./en.json": [
		800,
		800
	],
	"./es.json": [
		71191,
		191
	],
	"./ru.json": [
		39434,
		434
	],
	"./uk.json": [
		38975,
		975
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 4538;
module.exports = webpackAsyncContext;